<template>
  <div v-bind:style="{ cursor: isPreview ? 'pointer' : '' }">
    <router-link
      v-if="isPreview && slug"
      :to="{
        name: 'Article',
        params: { slug }
      }"
      class="d-block"
      style="text-decoration: none"
    >
      <v-sheet
        class="d-flex"
        dark
        tile
        max-width="100%"
        style="background-color: #050b1f !important"
      >
        <div class="grow pa-2 body-2">
          <div class="d-flex align-center fill-height">
            <span class="px-2" v-text="published" />
            /
            <span class="px-2" v-text="category" />

            <!-- <template v-if="$vuetify.breakpoint.mdAndUp">
            /
            <span class="px-2" v-text="`${comments} Comments`" />
          </template> -->

            <v-tooltip bottom style="z-index: 21">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon v-if="isRead">
                    mdi-check
                  </v-icon>
                </span>
              </template>
              <span>You already visited this blog post.</span>
            </v-tooltip>
          </div>
        </div>

        <v-sheet
          class="pa-2 d-md-inline-block text-center d-none"
          color="white"
          dark
          height="40"
          min-width="40"
          tile
          width="40"
        >
          <v-icon v-if="icon" v-text="icon" />
        </v-sheet>
      </v-sheet>

      <div class="pa-4">
        <base-title
          :title="title"
          class="text-truncate text-uppercase"
          style="color: black; margin-bottom: 0px!important"
        />

        <base-body :text="text" space="0" style="font-style:italic" />
      </div>

      <v-btn v-if="readMore" class="font-weight-bold" text>
        Read More
      </v-btn>
    </router-link>
    <v-divider v-if="divider" class="mt-6" />
  </div>
</template>

<script>
export default {
  name: "BlogCard",

  props: {
    isPreview: Boolean,
    category: String,
    comments: [Number, String],
    published: String,
    divider: Boolean,
    html: String,
    icon: String,
    prominent: Boolean,
    readMore: Boolean,
    src: String,
    text: String,
    title: String,
    slug: String,
    isRead: Boolean,
    truncate: [Number, String]
  },

  computed: {
    truncatedText() {
      if (!this.text) return "";

      const truncate = Number(this.truncate);

      return this.text.length > truncate
        ? this.text.slice(0, truncate) + " [...]"
        : this.text;
    }
  },

  methods: {
    onArticleClick() {
      if (!this.isPreview) {
        return;
      }
      this.$router.push({
        name: "Article",
        params: { slug: this.slug }
      });
    }
  }
};
</script>
